import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IEthnicity from '../interfaces/IEthnicity';


export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue, getValues} = useForm<IEthnicity>();
  const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'name', type: 'string'},
  ];
  
    return(
      <CrudEdit 
        model={'ethnicity'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Ethnicity successfully updated!'}  
        title={'Edit ethnicity'}
        getValues={getValues} 
      />
    )
}
